import { get_url_deal } from '@/utils/commons'
import request from '@/utils/request'

/* 关于我们*/
export function get_contact_email() {
  const url = get_url_deal('config/selectOverseasEmail.json/email_overseas')
  return request.get(url)
}

export function get_lang_type() {
  const url = get_url_deal('config/selectLangType.json')
  return request.get(url)
}
